<template>
  <div style="width: 100%; height: 300px; position: relative">
    <canvas ref="userOvationsBarChart"></canvas>
  </div>
</template>

<script>
export default {
  name: "UserOvationsBarChart",
  props: ["data"],
  mounted() {
    let chartData = {
      labels: [],
      datasets: [
        {
          label: "Assigned",
          backgroundColor: "#032aa0",
          maxBarThickness: 28,
          borderRadius: 20,
          borderSkipped: "middle",
          fill: true,
          data: [],
        },
        {
          label: "Given",
          backgroundColor: "#3cc0c9",
          maxBarThickness: 28,
          borderRadius: 20,
          borderSkipped: "middle",
          fill: true,
          data: [],
        },
      ],
    };

    for (
      let counter = 0, length = this.data.length;
      counter < length;
      counter++
    ) {
      chartData.labels.push(this.data[counter].name);
      chartData.datasets[0].data.push(this.data[counter].assigned);
      chartData.datasets[1].data.push(this.data[counter].given);
    }

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: "bottom",
          labels: {
            boxWidth: 10,
            usePointStyle: true,
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          /* ticks: {
            callback: function (value, index, values) {
              return this.getLabelForValue(value);
            },
          }, */
        },
        y: {
          stacked: true,
          beginAtZero: true,
        },
      },
    };

    let config = {
      type: "bar",
      data: chartData,
      options,
    };

    new Chart(this.$refs.userOvationsBarChart, config);
  },
};
</script>
